import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import SettingsTabs from "../AllTabs/SettingsTabs";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";

const TopUpHistory = () => {
  const { user, loading, refreshUserProfile } = useAuth();
  
  // Removed local currentBalance state, we will use user.walletBalance directly
  const [lists, setLists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const GetData = async (pageNum) => {
    // Safety check
    if (!user || !user.cid) return;
    
    setIsLoading(true);
    try {
      const response = await apiService.get(
        `${config.GETTOPUPHISTORYBYCOMPANYID}/${user.cid}`,
        pageSize,
        pageNum
      );
      console.log(response)
      setLists(response.data || []); 
      setPageNumber(response.pageNumber);
      setTotalPages(response.totalPages);
      setTotalRecords(response.totalRecords);
    } catch (error) {
      console.error("Error fetching top-up history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const GetPreviousPageData = () => {
    if (pageNumber > 1) {
      GetData(pageNumber - 1);
    }
  };

  const GetNextPageData = () => {
    if (pageNumber < totalPages) {
      GetData(pageNumber + 1);
    }
  };

  const GetPageData = (number) => {
    GetData(number);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  
  const renderPageNumbers = pageNumbers.map((number) => {
    const isActive = number === pageNumber ? "active" : "";
    return (
      <li
        className={`page-item ${isActive}`}
        key={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  useEffect(() => {
    if (!loading && user) {
        refreshUserProfile();
        GetData(1);
    }
  }, [loading]); 
  if (loading || !user) {
    return <p>Loading...</p>;
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <SettingsTabs pageName="TOPUPHISTORY" />
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h4 className="card-title">Wallet Transaction History</h4>
                    <p className="text-muted mb-0">
                      Your current Wallet balance is:{" "}
                      {/* Read directly from Context User object */}
                      <strong>{user.walletBalance ?? 0}</strong>
                    </p>
                  </div>
                </div>

                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-striped table-hover">
                      <thead className="table-light">
                        <tr>
                          <th>S.No</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th className="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.length > 0 ? (
                          lists.map((item, index) => {
                            const isCredit = item.status === "CREDITED";
                            
                            return (
                              <tr key={item.companyWalletId}>
                                <td>{(pageNumber - 1) * pageSize + (index + 1)}</td>
                                
                                <td>
                                  {moment(item.updatedDate).format(
                                    "DD MMM YYYY, hh:mm A"
                                  )}
                                </td>

                                <td>
                                  {isCredit ? (
                                    <span className="badge bg-success-subtle text-success">
                                      Credited
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger-subtle text-danger">
                                      Debited
                                    </span>
                                  )}
                                </td>

                                <td
                                  className={`text-end fw-bold ${
                                    isCredit
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                >
                                  {isCredit
                                    ? `+${item.amount}`
                                    : `-${item.amount}`}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted">
                              No transaction history found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                
                <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                  <div className="flex-shrink-0">
                    <div className="text-muted">
                      Showing{" "}
                      <span className="fw-semibold">{lists.length}</span> of{" "}
                      <span className="fw-semibold">{totalRecords}</span>{" "}
                      Results
                    </div>
                  </div>
                  <ul className="pagination pagination-separated pagination-sm mb-0">
                    <li
                      className={`page-item ${
                        pageNumber <= 1 ? "disabled" : ""
                      }`}
                      onClick={GetPreviousPageData}
                    >
                      <Link className="page-link" to="#">Previous</Link>
                    </li>

                    {renderPageNumbers}

                    <li
                      className={`page-item ${
                        pageNumber >= totalPages ? "disabled" : ""
                      }`}
                      onClick={GetNextPageData}
                    >
                      <Link className="page-link" to="#">Next</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopUpHistory;
